module.exports = __webpack_public_path__ + "static/second-2ad698e00e72e37557b3445e35c50bd7.jpg";